import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function customValidator(predicate: (value: any) => boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return predicate(control.value) ? null : { predicateError: true };
  };
}
